import { helper } from '@ember/component/helper';
import { isEmpty } from '@ember/utils';

export function strContains([source, str]: [string, string] /*, hash*/) {
  return (
    !isEmpty(str) &&
    !isEmpty(source) &&
    (source + '').toLowerCase().indexOf((str + '').toLowerCase()) > -1
  );
}

export default helper(strContains);
